window.addEventListener('DOMContentLoaded', () => {
  const interval = setInterval(() => {
    const dialog = document.querySelector('#polaris-css-lockdown-container');
    if (dialog && dialog.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
          @media(max-width: 749px){
            .polaris-button {
              transform: translateY(-70px);
            }
          }
      `;
      dialog.shadowRoot.appendChild(style);
      clearInterval(interval); 
    }
  }, 500);
});